export const EMAIL_REGEX =
    /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/i;

export const TYPES = {
    email: 1,
    calendar: 2,
    report: 3,
    execute: 4,
    webHook: 5,
    zendesk: 9,
    mailChimp_campaign: 11,
    geolocation: 15,
    executeZip: 16,
};

export const STATUS = {
    enabled: 1,
    disabled: 2,
    error: 3,
};

export const SERVER_TYPES = {
    gmail: 'Gmail',
    exchange: 'Exchange',
    imap: 'IMAP',
    office365: 'office365',
};

export const EXCHANGE_VERSIONS = {
    exchange2007: 'Exchange2007_SP1',
    exchange2010: 'Exchange2010',
    exchange2010SP1: 'Exchange2010_SP1',
    exchange2010SP2: 'Exchange2010_SP2',
    exchange2013: 'Exchange2013',
};

export const FREQUENCY = {
    minutesFrequency: 1,
    hoursFrequency: 2,
    dailyFrequency: 3,
    weeklyFrequency: 4,
    monthlyFrequency: 5,
    yearlyFrequency: 6,
};

export const DAYS = {
    monday: 'MON',
    tuesday: 'TUE',
    wednesday: 'WED',
    thursday: 'THU',
    friday: 'FRI',
    saturday: 'SAT',
    sunday: 'SUN',
};

export const REPORT_TYPE = {
    pdf: 'PDF',
    xls: 'XLS',
    doc: 'DOC',
};

export const EXECUTE_OPTIONS = {
    path: 1,
    code: 2,
};

export const ENTITY_OPTIONS = {
    accounts: 1,
    opportunities: 2,
};

export const FORM_SCHEMA = {
    context: {
        fields: {
            user: {
                table: 'tblUsuarios',
            },
            role: {
                table: 'tblRoles',
            },
            idTimeZone: {
                table: 'tblTimezones',
            },
        },
    },
    required: [
        'name',
        'description',
        'operation',
        'serverType',
        'serverHost',
        'serverPort',
        'exchangeServerVersion',
        'reportName',
        'subject',
        'executable',
        'frequency',
        'idTimeZone',
        'bodyOurEmail',
        'reportFormat',
        'minutesFrequency',
        'hoursFrequency',
        'dailyFrequency',
        'weeklyFrequency',
        'monthlyFrequency',
        'specificDays',
        'dayAt',
        'specificDaysMonth',
        'ordinalDay',
        'dayOfTheWeek',
        'eachMonth',
        'monthDayAt',
        'specificMonth',
        'userRoles',
        'role',
        'user',
        'entity',
        'keyAPI',
        'executableType',
        'internalEmailListOK',
        'internalEmailListERROR',
        'clientEmailListOK',
        'clientEmailListERROR',
        'fileAddress',
    ],
    properties: {
        name: {
            maxLength: 200,
            type: ['string'],
        },
        description: {
            maxLength: 200,
            type: ['string'],
        },
        operation: {
            type: ['integer'],
        },
        serverType: {
            type: ['string'],
        },
        serverHost: {
            maxLength: 200,
            type: ['string'],
        },
        serverPort: {
            type: ['integer'],
        },
        useSsl: {
            type: ['boolean'],
        },
        inboxExclude: {
            type: ['string'],
        },
        outboxInclude: {
            type: ['string'],
        },
        maxBodyLength: {
            type: ['integer'],
        },
        reportFormat: {
            type: ['string'],
        },
        impersonateUserEmail: {
            type: ['string'],
        },
        impersonateUserPassword: {
            type: ['string'],
        },
        webServicesUri: {
            type: ['string'],
        },
        reportName: {
            type: ['string'],
        },
        sendCopyTo: {
            type: ['string'],
        },
        executable: {
            type: ['string'],
        },
        bodyOurEmail: {
            type: ['string'],
        },
        hoursFrequency: {
            maximum: 23,
            type: ['integer'],
        },
        specificDays: {
            maximum: 31,
            type: ['integer'],
        },
        specificDaysMonth: {
            maximum: 31,
            type: ['integer'],
        },
        enabled: {
            type: ['boolean'],
        },
        entity: {
            type: ['integer'],
        },
    },
    layout: {
        id: 'crons',
        uiGrid: 'linearVertical',
        composition: [
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_info',
                expandable: true,
                composition: [
                    {
                        schemaId: 'name',
                        label: 'cfm_label_cron_name',
                        uiType: 'text',
                        placeholder: 'cfm_placeholder_type_value',
                    },
                    {
                        schemaId: 'description',
                        uiType: 'text',
                        label: 'cfm_label_description',
                        placeholder: 'cfm_placeholder_type_value',
                    },
                    {
                        schemaId: 'operation',
                        label: 'cfm_label_cron_type',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                    },
                    {
                        schemaId: 'enabled',
                        label: 'cfm_label_enabled',
                        uiType: 'checkbox',
                        isHidden: false,
                    },
                    {
                        schemaId: 'geoMessage',
                        uiType: 'message',
                        isHidden: true,
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_parameters',
                expandable: true,
                isHidden: true,
                composition: [
                    {
                        schemaId: 'serverType',
                        label: 'cfm_label_server_type',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'serverHost',
                        label: 'cfm_label_server_host',
                        uiType: 'text',
                        isHidden: true,
                        placeholder: 'cfm_placeholder_type_value',
                    },
                    {
                        schemaId: 'serverPort',
                        label: 'cfm_label_server_port',
                        uiType: 'number',
                        isHidden: true,
                        placeholder: 'cfm_placeholder_type_value',
                    },
                    {
                        schemaId: 'useSsl',
                        label: 'cfm_label_use_ssl',
                        uiType: 'checkbox',
                        isHidden: true,
                    },
                    {
                        schemaId: 'inboxExclude',
                        label: 'cfm_label_exclude_from_inbox',
                        uiType: 'text',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'outboxInclude',
                        label: 'cfm_label_include_from_outbox',
                        uiType: 'text',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'maxBodyLength',
                        label: 'cfm_label_max_body_size',
                        uiType: 'checkbox',
                        helpTip: 'cfm_label_max_body_size_info',
                        isHidden: true,
                    },
                    {
                        schemaId: 'exchangeServerVersion',
                        label: 'cfm_label_exchange_version',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'impersonateUserEmail',
                        label: 'cfm_label_impersonate_user_email',
                        uiType: 'text',
                        helpTip: 'cfm_label_impersonate_user_email_info',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'impersonateUserPassword',
                        label: 'cfm_label_impersonate_user_pass',
                        uiType: 'text',
                        helpTip: 'cfm_label_impersonate_user_pass_info',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'webServicesUri',
                        label: 'cfm_label_webservices_uri',
                        uiType: 'text',
                        helpTip: 'cfm_label_webservices_uri_info',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'reportName',
                        label: 'cfm_label_select_report',
                        uiType: 'text',
                        placeholder: 'label_selectone',
                        buttonClassName: 'fs-form__field__reportName__button',
                        isHidden: true,
                        isReadOnly: true,
                    },
                    {
                        schemaId: 'sendCopyTo',
                        label: 'cfm_label_send_email_customer',
                        uiType: 'text',
                        placeholder: 'cfm_label_send_customer_placeholder',
                        isHidden: true,
                    },

                    {
                        schemaId: 'subject',
                        label: 'cfm_label_subject_email',
                        uiType: 'text',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'bodyOurEmail',
                        label: 'cfm_label_body_email',
                        uiType: 'textarea',
                        placeholder: 'cfm_placeholder_type_value',
                        isHidden: true,
                    },
                    {
                        schemaId: 'reportFormat',
                        label: 'cfm_label_format_email',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'executableType',
                        label: 'cfm_label_executable_type',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'executable',
                        label: 'cfm_label_select_path',
                        uiType: 'text',
                        placeholder: 'cfm_label_select_path_placeholder',
                        isHidden: true,
                    },
                    {
                        schemaId: 'fileAddress',
                        uiType: 'file',
                        placeholder: 'cfm_label_drag_and_drop_inactive',
                        activePlaceholder: 'cfm_label_drag_and_drop_active',
                        isHidden: true,
                        limit: 1,
                        fileTypes: ['application/zip', 'application/x-zip-compressed'],
                    },
                    {
                        schemaId: 'fileName',
                        label: 'cfm_label_select_upload_local_name',
                        uiType: 'text',
                        placeholder: ' ',
                        isHidden: true,
                        isReadOnly: true,
                    },
                    {
                        schemaId: 'isInternalEmailOK',
                        label: 'cfm_action_send_email_ok_internal',
                        uiType: 'checkbox',
                        isHidden: true,
                    },
                    {
                        schemaId: 'internalEmailListOK',
                        uiType: 'text',
                        label: 'cfm_label_send_email_ok_internal',
                        placeholder: 'cfm_label_send_customer_placeholder',
                        isHidden: false,
                    },
                    {
                        schemaId: 'isInternalEmailERROR',
                        label: 'cfm_action_send_email_nok_internal',
                        uiType: 'checkbox',
                        isHidden: true,
                    },
                    {
                        schemaId: 'internalEmailListERROR',
                        uiType: 'text',
                        label: 'cfm_label_send_email_nok_internal',
                        placeholder: 'cfm_label_send_customer_placeholder',
                        isHidden: false,
                    },
                    {
                        schemaId: 'isClientEmailOK',
                        label: 'cfm_action_send_email_ok_customer',
                        uiType: 'checkbox',
                        isHidden: true,
                    },
                    {
                        schemaId: 'clientEmailListOK',
                        uiType: 'text',
                        label: 'cfm_label_send_email_ok_customer',
                        placeholder: 'cfm_label_send_customer_placeholder',
                        isHidden: false,
                    },
                    {
                        schemaId: 'isClientEmailERROR',
                        label: 'cfm_action_send_email_nok_customer',
                        uiType: 'checkbox',
                        isHidden: true,
                    },
                    {
                        schemaId: 'clientEmailListERROR',
                        uiType: 'text',
                        label: 'cfm_label_send_email_nok_customer',
                        placeholder: 'cfm_label_send_customer_placeholder',
                        isHidden: false,
                    },
                    {
                        schemaId: 'entity',
                        label: 'cfm_label_entity',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'geoOppsInfo',
                        uiType: 'message',
                        isHidden: true,
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_time',
                expandable: true,
                composition: [
                    {
                        schemaId: 'frequency',
                        label: 'cfm_label_cron_frequency',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: false,
                    },
                    {
                        schemaId: 'minutesFrequency',
                        label: 'cfm_label_execute_every',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'hoursFrequency',
                        label: 'cfm_label_execute_every',
                        uiType: 'number',
                        placeholder: 'cfm_placeholder_input_hours',
                        isHidden: true,
                    },
                    {
                        schemaId: 'dailyFrequency',
                        label: 'cfm_label_options',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'weeklyFrequency',
                        label: 'cfm_label_execute_every',
                        uiType: 'multiList',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'monthlyFrequency',
                        label: 'cfm_label_options',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'specificDays',
                        label: 'cfm_label_execute_every',
                        uiType: 'number',
                        placeholder: 'cfm_placeholder_input_days',
                        isHidden: true,
                    },
                    {
                        schemaId: 'dayAt',
                        label: 'cfm_label_at',
                        uiType: 'time',
                        outputType: 'string',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'specificDaysMonth',
                        label: 'cfm_label_execute_by_weekly_1',
                        uiType: 'number',
                        placeholder: 'cfm_placeholder_input_monthly_day',
                        isHidden: true,
                    },
                    {
                        schemaId: 'ordinalDay',
                        label: 'cfm_label_execute_by_monthly_number',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'dayOfTheWeek',
                        label: 'cfm_label_day_of_week',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'eachMonth',
                        label: 'cfm_label_each_number_month',
                        uiType: 'number',
                        placeholder: 'cfm_placeholder_input_monthly_months',
                        isHidden: true,
                    },
                    {
                        schemaId: 'monthDayAt',
                        label: 'cfm_label_at',
                        uiType: 'time',
                        outputType: 'string',
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'specificMonth',
                        label: 'common_month',
                        uiType: 'list',
                        placeholder: 'introduce el mes',
                        isHidden: true,
                    },
                    {
                        schemaId: 'frequencyInfo',
                        uiType: 'message',
                        isHidden: true,
                    },
                    {
                        schemaId: 'idTimeZone',
                        label: 'label_timezone',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: false,
                    },
                ],
            },
            {
                uiType: 'section',
                uiGrid: 'linearVertical',
                label: 'cfm_label_user_rols',
                expandable: true,
                composition: [
                    {
                        schemaId: 'userRoles',
                        label: 'label_selectone',
                        uiType: 'list',
                        placeholder: 'label_selectone',
                        isHidden: false,
                    },
                    {
                        schemaId: 'role',
                        label: 'cfm_label_role',
                        uiType: 'list',
                        isFuzzy: true,
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                    {
                        schemaId: 'user',
                        label: 'cfm_label_user',
                        uiType: 'list',
                        isFuzzy: true,
                        placeholder: 'label_selectone',
                        isHidden: true,
                    },
                ],
            },
        ],
    },
};
